export const LocalStorageManager = {
    getOrgPrimaryId: function () {
        const orgPrimaryId = localStorage.getItem('orgPrimaryId');
        return orgPrimaryId || null;
    },

    setOrgPrimaryId: function (orgPrimaryId: string) {
        localStorage.setItem('orgPrimaryId', orgPrimaryId);
    },

     removeOrgPrimaryId: function () {
        if (this.getOrgPrimaryId()) {
            localStorage.removeItem('orgPrimaryId');
        }
    },

    getOrgdata: function () {
        const orgdata = localStorage.getItem('orgdata');
        return orgdata || null;
    },

    setOrgdata: function (orgdata: string) {
        localStorage.setItem('orgdata', orgdata);
    },

     removeOrgdata: function () {
        if (this.getOrgdata()) {
            localStorage.removeItem('orgdata');
        }
    },

    //Admin
    getAdminPrimaryId: function () {
        const adminPrimaryId = localStorage.getItem('adminPrimaryId');
        return adminPrimaryId || null;
    },

    setAdminPrimaryId: function (adminPrimaryId: string) {
        localStorage.setItem('adminPrimaryId', adminPrimaryId);
    },

    removeAdminPrimaryId: function () {
        if (this.getAdminPrimaryId()) {
            localStorage.removeItem('adminPrimaryId');
        }
    },

     //Admin
     getUserName: function () {
        const userName = localStorage.getItem('userName');
        return userName || null;
    },

    setUserName: function (userName: string) {
        localStorage.setItem('userName', userName);
    },

    removeUserName: function () {
        if (this.getUserName()) {
            localStorage.removeItem('userName');
        }
    },

   
};
